var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.3 56.3",
    enableBackground: "new 0 0 56.3 56.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_871_",
    opacity: 0.98,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 28.1,
    cy: 28.1,
    r: 27.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_686_",
    fill: "#FFFFFF",
    d: "M32.6,24.8h-3.4v-2.2c0-0.8,0.6-1,0.9-1c0.4,0,2.4,0,2.4,0v-3.7l-3.3,0   c-3.6,0-4.5,2.7-4.5,4.5v2.4h-2.1v3.8h2.1c0,4.8,0,10.7,0,10.7h4.4c0,0,0-5.9,0-10.7h3L32.6,24.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.2c43dfa9fab855b74fc0f4869b0f08f0.svg";
export { ForwardRef as ReactComponent };